import * as React from "react";
import type { SVGProps } from "react";
const BulletedList04Icon = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="1em" height="1em" fill="none" style={{
  userSelect: "none",
  flexShrink: 0
}} {...props}><path fill="currentColor" fillRule="evenodd" d="M9.163 12 7 9.837 4.837 12 7 14.163zM7.592 9.245a.837.837 0 0 0-1.184 0l-2.163 2.163a.837.837 0 0 0 0 1.184l2.163 2.163a.837.837 0 0 0 1.184 0l2.163-2.163a.837.837 0 0 0 0-1.184z" clipRule="evenodd" /></svg>;
export default BulletedList04Icon;